module.exports = __webpack_public_path__ + "static/media/GraphMenuWhite.f2a18d25.svg";